export const TRUE_WEALTH_PRIMARY_COLOR = "#0d2d69"; //navy 
export const TRUE_WEALTH_SECONDARY_COLOR = "#098cea"; //blue
export const TRUE_WEALTH_TERTIARY_COLOR = "#fff"; //white
export const TRUE_WEALTH_PRIMARY_LIGHT_COLOR = "#999FC2"; //light
export const TRUE_WEALTH_PULSE_COLOR = "#FFB800"; //orange
export const TRUE_WEALTH_HIGHLIGHT_COLOR = "#77c970" //vibrant 
